<template>

<div class="steps">

	<div v-for="step in total" :key="step" class="steps-item" :class="{'is-current': step === current, 'is-completed': step < current}">{{ step }}</div>

</div>

</template>

<script>

export default {

	props: ['total', 'current']

}

</script>

<style scoped>

.steps {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-bottom: 40px;
	height: 13px;
	border-bottom: 1px solid var(--color-grey-light);
	width: 100%;
}

.steps-item {
	width: 24px;
	height: 24px;
	border-radius: 50px;
	border: 1px solid var(--color-grey-light);
	text-align: center;
	line-height: 22px;
	font-size: 12px;
	color: var(--color-grey-light);
	margin: 0px 2px;
	background-color: #fff;
	transition: all 100ms linear;
}

.steps-item.is-current {
	color: var(--color-blue-light);
	border-color: var(--color-blue-light);
}

.steps-item.is-completed {
	color: #fff;
	background-color: var(--color-blue-light);
	border-color: var(--color-blue-light);
}

</style>